import { Star } from "@phosphor-icons/react";

export function StarRating({ value = 0, size = 16, onChange, testid }) {
  const stars = [1, 2, 3, 4, 5];
  return (
    <div className="flex items-center gap-0.5" data-testid={testid}>
      {stars.map((s) => (
        <button
          key={s}
          type="button"
          disabled={!onChange}
          onClick={() => onChange && onChange(s)}
          className={onChange ? "active:scale-90 transition-transform" : "cursor-default"}
          data-testid={onChange ? `${testid}-${s}` : undefined}
        >
          <Star size={size} weight={s <= Math.round(value) ? "fill" : "regular"} className={s <= Math.round(value) ? "text-[#FF5A36]" : "text-zinc-300"} />
        </button>
      ))}
    </div>
  );
}
